<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">


				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
						<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
							<div>
								<h2 class="text-white pb-2 fw-bold">About</h2>
							</div>
							<div class="ml-md-auto py-2 py-md-0">
								<div class="form-group">
									<div class="input-group">
										<input type="text" class="form-control" placeholder="Cari data ...">
										<div class="input-group-append">
											<button class="btn btn-primary" type="button" title="Tambah Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">

						


						<table class="table-kiken table table-head-bg-info" width="100%" >
							<thead>
								<tr class="bg-primary">
									<th scope="col" style="width: 5%">No</th>

									<th scope="col" style="width: 60%">Judul</th>
                                    <th scope="col" style="width: 20%">Editor</th>
                                    <th scope="col" style="width: 15%"></th>
								</tr>
							</thead>
							<tbody>
								<tr class="h_isitable">
									<td class="text-center">1</td>
									<td >Tes manfaat dari Halaman ini dadalah untuk mengecek</td>
                                    <td >Kiken Sukma Batara</td>
                                    <td class="text-center">
                                        <button class="btn btn-info btn-icon btn-round btn-xs" title="Detil Data" data-toggle="modal" data-target="#m_lihat_data"><i class="fab fa-sistrix"></i></button>
                                        &nbsp;
                                        <button class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-pencil-alt"></i></button>
                                        &nbsp;
                                        <button class="btn btn-danger btn-icon btn-round btn-xs" title="Hapus Data"><i class="fas fa-trash-alt"></i></button>

                                    </td>
								</tr>

							</tbody>
						</table>



					</div>

				</div>




                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form >
                                    <div class="modal-body">
                                        <div id="editor"></div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn bgcol-info btn-xs">SIMPAN</button>
                                        <button type="button" class="btn bgcol-danger btn-xs" data-dismiss="modal">BATAL</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">EDIT DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <img class="img-fluid" src="http://36.89.95.163:5100/uploads/1562777027745.jpg" alt="">
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn bgcol-warning btn-xs">Edit</button>
                                    <button type="button" class="btn bgcol-danger btn-xs" data-dismiss="modal">Batal</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-header">
                                    <h5 class="modal-title">GAMBAR DETIL</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <img class="img-fluid" src="http://36.89.95.163:5100/uploads/1562777027745.jpg" alt="">
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn bgcol-danger btn-xs" data-dismiss="modal">Keluar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->




			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>

export default {

    data() {
        return {
            data_load : false
        }
    },
    methods: {
        getView: function() {
            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value
                })
            })
                .then(res => res.json())
                .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.cek_load_data = false;
            });
        },

        addData: function() {
            var formData = new FormData();

            formData.append("judul", this.form.judul);
            formData.append("sumber", this.form.sumber);
            formData.append("deskripsi", this.form.deskripsi);
            formData.append("unit_kerja", this.form.unit_kerja);
            formData.append("isi", CKEDITOR.instances.editor.getData());
            formData.append("file", this.form.file);

            fetch(ADD_URL + "addData", {
                method: "POST",
                headers: {
                authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            }).then(res_data => {
                this.alertku("success", "sukses menambah data");
                this.getView();
            });
        },

        editData: function() {
            var formData = new FormData();
            formData.append("id", this.form.id);
            formData.append("judul", this.form.judul);
            formData.append("sumber", this.form.sumber);
            formData.append("deskripsi", this.form.deskripsi);
            formData.append("unit_kerja", this.form.unit_kerja);
            formData.append("isi", CKEDITOR.instances.editor1.getData());
            formData.append("file", this.form.file);
            formData.append("file_old", this.file_old);

            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        selectData: function(data) {
            console.log(data);
            this.form = {
                id : data.id,
                judul : data.judul,
                sumber : data.sumber,
                deskripsi : data.deskripsi,
                isi : data.isi,
                foto : data.foto,
                unit_kerja : data.unit_kerja,
                status : data.status,
                keterangan : data.keterangan,
                createBy : data.createBy,
                createAt : data.createAt
            };
            this.file_old =  data.foto;
            CKEDITOR.instances.editor1.setData(data.isi);
        },


        removeData: function(idnya, file) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                id: idnya,
                file: file
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },


    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}



            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        }
        
    },
    mounted() {

        CKEDITOR.replace( 'editor',{
            // width: 793.700787,
            height: 1122.519685,
            startupFocus : true,
            tabindex: false
        });

                
        CKEDITOR.replace( 'editor1',{
            // width: 793.700787,
            height: 1122.519685,
        });

    },

}
</script>